import React from 'react'
import {
    Button, Modal
} from 'react-bootstrap-v5';

export function ChangeStatus({ isOpen, onSubmitEvent, handleClose, title, message }) {
    return (
        <Modal
            aria-lambelledby="contained-modal-title-vcenter"
            centered
            show={isOpen}
            onHide={() => handleClose()}
        >
            <Modal.Header closeButton>
                <Modal.Title className="text-primary">{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h>{message}</h>
            </Modal.Body>
            <Modal.Footer className="w-100 text-center">
                <Button variant="secondary" onClick={() => handleClose()}>
                    No
                </Button>
                <Button variant="primary" onClick={() => onSubmitEvent()}>
                    Yes
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export function DeleteItem({ isOpen, onSubmitEvent, handleClose, title, message }) {
    return (
        <Modal
            aria-lambelledby="contained-modal-title-vcenter"
            centered
            show={isOpen}
            onHide={() => handleClose()}
        >
            <Modal.Header closeButton>
                <Modal.Title className="text-primary">{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h6>{message}</h6>
            </Modal.Body>
            <Modal.Footer className="w-100 text-center">
                <Button variant="success" onClick={() => handleClose()}>
                    No
                </Button>
                <Button variant="danger" onClick={() => onSubmitEvent()}>
                    Yes
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export function AddChargeModal({ isOpen, onSubmitEvent, handleClose, title, child, buttonText }) {
    return (
        <Modal
            aria-lambelledby="contained-modal-title-vcenter"
            centered
            show={isOpen}
            onHide={() => handleClose()}
        >
            <Modal.Header closeButton>
                <Modal.Title className="text-primary">{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {child}
            </Modal.Body>
            <Modal.Footer className="w-100 text-center">
                <Button variant="secondary" onClick={() => handleClose()}>
                    {buttonText.no}
                </Button>
                <Button variant="primary" onClick={() => onSubmitEvent()}>
                    {buttonText.yes}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export function AddAmountModal({ isOpen, onSubmitEvent, handleClose, title, child, buttonText, centerBtn }) {
    return (
        <Modal
            aria-lambelledby="contained-modal-title-vcenter"
            centered
            show={isOpen}
            onHide={() => handleClose()}
        >
            <Modal.Header closeButton>
                <Modal.Title className="text-primary">{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {child}
            </Modal.Body>
            <Modal.Footer className={(centerBtn ? ` w-100 justify-content-center` : `w-100`)}>
                <Button variant="secondary" onClick={() => handleClose()}>
                    {buttonText.no}
                </Button>
                <Button variant="primary" onClick={() => onSubmitEvent()}>
                    {buttonText.yes}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}